import { HttpResponse } from '@angular/common/http'
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { User } from 'src/app/models'
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model'
import {
  DocumentService,
  SecurityService,
  WorkflowContextService,
} from 'src/app/services'

@Component({
  selector: 'wm-profile-image-section',
  standalone:false,
  templateUrl: './profile-image-section.component.html',
  styleUrls: ['./profile-image-section.component.scss']
})
export class ProfileImageSectionComponent {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>

  selectedFile: File | null = null
  uploading = false
  removePhotoModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Profile Picture',
    modalSubDescp: 'Are you sure you want to remove your profile picture?',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    replaceYesWith: 'Remove',
    replaceNoWith: 'Cancel',
    status: 'default'
  }

  constructor(
    private documentService: DocumentService,
    private context: WorkflowContextService,
    private _securitySvc:SecurityService,
    private toastr: ToastrService
  ) {}
  get profileImage(): string | null {
    const path = this.context.user?.userProfileImageURL
    if (!path) return null

    return path.startsWith('http')
      ? path
      : `${window.location.origin}${path}`
  }

  triggerFileInput(input: HTMLInputElement) {
    input.click()
  }

  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement
    if (!input.files?.length) return

    this.selectedFile = input.files[0]
    await this.uploadAndSaveProfileImage()
  }
  @Output() userUpdated = new EventEmitter<User>()

  private uploadAndSaveProfileImage(): void {
    if (!this.selectedFile || !this.context.user?.id) {
      return
    }
  
    this.uploading = true
  
    this.documentService.upload(this.selectedFile, {
      name: this.selectedFile.name,
      parentPath: ['users', this.context.user.id, 'profile-image'],
      filename: this.selectedFile.name,
      origName: this.selectedFile.name,
      category: 'ProfileImage'
    }).subscribe({
      next: event => {
        if (!(event instanceof HttpResponse)) return
  
        const imagePath = event.body?.path
        if (!imagePath) return

        this._securitySvc.getUser(this.context.user.id).subscribe(currentUser => {

          const updatedUser = {
            ...currentUser, 
            userProfileImageURL: imagePath, 
          }

          this._securitySvc.saveUser(updatedUser).subscribe({
            next: () => {
              this.context.user = {
                ...this.context.user!,
                userProfileImageURL: imagePath
              }
    
              this.context.user$.emit(this.context.user)
              this.userUpdated.emit(this.context.user as User)
    
              this.selectedFile = null
              this.uploading = false
            },
            error: err => {
              // console.error('Failed to save user', err)
              this.toastr.error('Failed to save profile image')
              this.uploading = false
            }
          })
        });
      },
      error: err => {
        // console.error('Upload failed', err)
        this.uploading = false
      }
    })
  }

  openRemovePhotoConfirm() {
    this.removePhotoModalData = {
      ...this.removePhotoModalData,
      open: true
    }
  }

  closeRemovePhotoConfirm() {
    this.removePhotoModalData = {
      ...this.removePhotoModalData,
      open: false
    }
  }

  confirmRemovePhoto() {
    this.closeRemovePhotoConfirm()
    this.onRemoveClick()
  }

  onRemoveClick() {
    if (!this.context.user) return;
  
    this.uploading = true;
  
    const updatedUser = {
      ...this.context.user,
      userProfileImageURL: null
    };
  
    this._securitySvc.saveUser(updatedUser).subscribe({
      next: () => {
        this.context.user = updatedUser;
        this.context.user$.emit(this.context.user);
        this.userUpdated.emit(this.context.user as User);
        this.uploading = false;
      },
      error: err => {
        // console.error('Failed to remove profile image', err);
        this.toastr.error('Failed to remove profile image');
        this.uploading = false;
      }
    });
  }
  
}
